// Custom Turbo actions

import { StreamActions } from "@hotwired/turbo";

// Page refresh action
const sessionID = Math.random().toString(36).slice(4);

StreamActions.refresh = function () {
  if (this.getAttribute("session-id") !== sessionID) {
    window.Turbo.cache.exemptPageFromPreview();
    window.Turbo.visit(window.location.href, { action: "replace" });
  }
};

document.addEventListener("turbo:before-fetch-request", (event) => {
  event.detail.fetchOptions.headers["X-Turbo-Session-ID"] = sessionID;
});
